const USER_ROLES = {
    SUPER_ADMIN: "0",
    COMPANY_ADMIN: "1",
    COMPANY_LOCATION_LEADER: "2",
    COMPANYUSER: "4",
    RESELLER: "5",
  };
  
  export default USER_ROLES;